import * as React from 'react';
import {AppConfig, AppConfigMapKey} from './AppConfig';
import {URLS} from '../../util/ConfigConstants';

export interface BulkActionConfig {
    id: string;
    label: string;
    flagKey: AppConfigMapKey;
    route: string;
    component: React.LazyExoticComponent<any>;
}

/**
 * Registry of all bulk actions available in the Action Type dropdown.
 * To add a new action:
 * 1. Add a feature flag to AppConfigMapKey enum
 * 2. Add the flag to AppConfig.json per environment
 * 3. Add a route to URLS.PAGES in ConfigConstants.tsx
 * 4. Create the page component
 * 5. Add an entry here
 */
export const BULK_ACTION_REGISTRY: BulkActionConfig[] = [
    {
        id: 'bulk-edit',
        label: 'Bulk Edit',
        flagKey: AppConfigMapKey.ENABLE_BULK_EDIT,
        route: URLS.PAGES.BULK_EDIT,
        component: React.lazy(() => import('../BulkEditPage'))
    }
];

/**
 * Returns only the actions whose feature flags are enabled.
 */
export function getEnabledBulkActions(): BulkActionConfig[] {
    return BULK_ACTION_REGISTRY.filter(action => AppConfig.getConfigValue(action.flagKey));
}
